export default __webpack_public_path__ + "static/media/center-right.bfd703ba.png";